module.exports = __webpack_public_path__ + "static/media/programa-370-coromoto-basilica.7f6b871c.png";